import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-276c9f39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-name" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "company-logo-txt" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "company-logo-title" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userAccount.iconUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "company-logo-img",
          src: _ctx.userAccount.iconUrl,
          alt: ""
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "company-logo-title-link",
        href: `/corporation/${_ctx.userAccount.userAccountId}`
      }, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.userAccount.name), 1)
      ], 8, _hoisted_4),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("a", {
          class: "company-logo-link",
          href: _ctx.userAccount.url,
          target: "_blank"
        }, _toDisplayString(_ctx.userAccount.url), 9, _hoisted_6)
      ], true)
    ])
  ]))
}